import { Text, XStack } from 'tamagui';
import { colors } from '../theme/colors';

/**
 * Small accent-tinted pill used to mark features gated behind a paid
 * subscription tier. Visible next to layer toggles, on cards that
 * display Pro-only data, and anywhere we want a single-eyebrow signal
 * "this is a Pro feature."
 *
 * Re-uses the `accentCerulean` palette + the standard chip-tint
 * pattern (color + '1A' background, color + '33' border) used by
 * `TimePill` so the badge feels consistent with other tinted chips.
 *
 * Visual only — does not capture taps. Wrap in a Pressable if the
 * badge itself should be the affordance.
 */
export function ProBadge({ label = 'Pro' }: { label?: string | undefined}) {
  return (
    <XStack
      paddingHorizontal={6}
      paddingVertical={2}
      borderRadius={999}
      backgroundColor={colors.accentCerulean + '1A'}
      borderWidth={1}
      borderColor={colors.accentCerulean + '33'}
      alignItems="center"
      justifyContent="center"
    >
      <Text
        fontSize={10}
        fontWeight="700"
        letterSpacing={0.4}
        color={colors.accentCerulean}
      >
        {label.toUpperCase()}
      </Text>
    </XStack>
  );
}
